import { createApp } from "vue";
import App from "./App.vue";
import { createRouter, createWebHistory } from "vue-router";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "./assets/Style.css";
import "./assets/responsive.css";
import GlobalPresence from "./pages/GlobalPresence.vue";
import ScrollReveal from 'scrollreveal';

// Font Awesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// Import only the icons you need
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import FoundationPage from "./pages/FoundationPage.vue";
import InvestorRelations from "./pages/InvestorRelations.vue";
library.add(faAngleRight);

const Home = () => import("./pages/Home.vue");
const About = () => import("./pages/About.vue");
const Services = () => import("./pages/Services.vue");
const GetTouch = () => import("./pages/GetTouch.vue");
const ErrorPage = () => import("./pages/NotFound.vue");
const index = () => import("./pages/[dynamic]/index.vue");

const routes = [
  { path: "/", component: Home },
  { path: "/home", component: Home },
  { path: "/about", component: About },
  { path: "/services", component: Services },
  { path: "/services/:dynamic", component: index },
  { path: "/getTouch", component: GetTouch },
  { path: "/corporate-companies", component: GlobalPresence },
  { path: "/foundation", component: FoundationPage },
  { path: "/investor-relations", component: InvestorRelations },
  { path: "/:NotFound(.*)*", component: ErrorPage, meta: { hideLayout: true } },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
    scrollBehavior() {
    return { top: 0, behavior: 'instant' };
  },
});

const app = createApp(App);
app.use(router);
app.component("font-awesome-icon", FontAwesomeIcon);

// Initialize ScrollReveal with default config
window.sr = ScrollReveal({
  origin: 'bottom',
  distance: '20px',
  duration: 1000,
  delay: 200,
  easing: 'ease-in-out',
});

app.mount("#app");
